import React from 'react';

import { Badge } from '@/components/ui/badge';
import { getQcScoreToneClass } from '@/pages/qc/qcDetail.utils';
import { formatAggregateScore } from '@/pages/qc/utils';

interface QcScoreBadgeProps {
  score?: number;
}

export const QcScoreBadge: React.FC<QcScoreBadgeProps> = ({ score }) => {
  if (score === undefined || score === null) {
    return <span className="text-muted-foreground">--</span>;
  }

  return (
    <Badge
      variant="outline"
      className={`justify-center border-transparent ${getQcScoreToneClass(score, 'default')}`}
    >
      {formatAggregateScore(score)}
    </Badge>
  );
};
